<template>
  <ul>
    <DpplListItem
      v-for="(_, i) in Array(numberToLoad)"
      :key="i"
      class="skeleton-settings-list-item"
    >
      <template #left>
        <div class="section pl-6 pr-11">
          <v-skeleton-loader
            type="heading"
            width="200"
          />
        </div>
        <div class="section pl-11">
          <v-skeleton-loader
            type="text"
            width="200"
            height="20"
          />
        </div>
      </template>
      <template #right>
        <div class="section">
          <v-skeleton-loader
            type="text"
            height="16"
            width="60"
          />
        </div>
        <div class="section pr-8">
          <v-skeleton-loader
            type="text"
            width="90"
            height="16"
          />
        </div>
      </template>
    </DpplListItem>
  </ul>
</template>

<script>
import DpplListItem from '@/components/datapeople/DpplListItem.vue';

export default {
  name: 'SettingsListLoader',
  components: {
    DpplListItem,
  },
  props: {
    numberToLoad: {
      type: Number,
      default: 5,
    },
  },
};
</script>

<style lang="less" scoped>
.section {
  padding: 0 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.dppl-list-item:hover) {
  box-shadow: none;
  cursor: progress;
}
.right-side-loader, .left-side-loader :deep(.v-skeleton-loader__list-item) {
  height: 100%;
}
.left-side-loader :deep(.v-skeleton-loader__list-item) {
  height: 100%;
}
:deep(.v-skeleton-loader__heading) {
  width: 100%;
  height: 20px;
}
:deep(.v-skeleton-loader__text) {
  width: 100%;
  height: 16px;
  border-radius: 10px;
  margin: 0;
}
</style>
